var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDoneIcon = function SvgDoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16A8 8 0 118 0a8 8 0 010 16zm4.207-11.112l-1.124-.769a.708.708 0 00-.962.167L7.063 8.533 5.37 7.383a.696.696 0 00-.957.161l-.79 1.098a.663.663 0 00.166.931l2.258 1.538.016.01 1.107.758a.706.706 0 00.962-.167l4.242-5.893a.654.654 0 00-.167-.931z",
    fill: "currentColor"
  })));
};
export default SvgDoneIcon;